export const CHAOS_CHRONICLES_PROMO = "https://customer-assets.emergentagent.com/job_3828a6dc-0502-44a7-ab45-71a567e1d959/artifacts/nqif8u1e_generated_image_20260124_035327_1.png";
export const GAME_PREVIEW_IMAGE = "https://customer-assets.emergentagent.com/job_3828a6dc-0502-44a7-ab45-71a567e1d959/artifacts/wblbvhal_Screenshot_20260129-171852.Chrome.png";
export const GARY_MASCOT = "https://customer-assets.emergentagent.com/job_1b7103cb-60b2-49d7-8677-886184523930/artifacts/xslf9n4k_generated_image_20260124_034300_1.png";

export const floatingEmojis = [
  "🐐", "⬡", "₿", "◆", "🎮", "📚", "💎", "🚀", "⛓️", "🏆",
  "💰", "🔥", "⚡", "🌟", "✨", "🎯", "🪙", "🎲", "📖", "🐐"
];

export const socialLinks = [
  { name: "Instagram", url: "https://instagram.com/blockquestofficial", icon: "instagram" }
];
